import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import { useAuthStore } from '@shared/store/authStore';
import { useThemeStore } from '../../store/themeStore';
import { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode';

const navItems = [
  {
    path: '/',
    label: 'Главная',
    icon: (active: boolean) => (
      <svg className={clsx('w-6 h-6', active ? 'text-emerald-600' : 'text-gray-400')} 
           fill={active ? 'currentColor' : 'none'} 
           stroke="currentColor" 
           viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    path: '/profile',
    label: 'Личный кабинет',
    icon: (active: boolean) => (
      <svg className={clsx('w-6 h-6', active ? 'text-emerald-600' : 'text-gray-400')} 
           fill={active ? 'currentColor' : 'none'} 
           stroke="currentColor" 
           viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
  },
  {
    path: '/group-lessons',
    label: 'Группы',
    icon: (active: boolean) => (
      <svg className={clsx('w-6 h-6', active ? 'text-emerald-600' : 'text-gray-400')} 
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
  },
  {
    path: '/personal-training',
    label: 'Персональные',
    icon: (active: boolean) => (
      <svg className={clsx('w-6 h-6', active ? 'text-emerald-600' : 'text-gray-400')} 
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
  },
  {
    path: '/courts',
    label: 'Корты',
    icon: (active: boolean) => (
      <svg className={clsx('w-6 h-6', active ? 'text-emerald-600' : 'text-gray-400')} 
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    ),
  },
  {
    path: '/beauty',
    label: 'Beauty',
    icon: (active: boolean) => (
      <svg className={clsx('w-6 h-6', active ? 'text-emerald-600' : 'text-gray-400')}
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    path: '/ai-assistant',
    label: 'AI Помощник',
    icon: (active: boolean) => (
      <svg className={clsx('w-6 h-6', active ? 'text-emerald-600' : 'text-gray-400')}
           fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
      </svg>
    ),
  },
];

interface DesktopSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onLoginClick?: () => void;
}

export function DesktopSidebar({ isOpen, onClose, onLoginClick }: DesktopSidebarProps) {
  const { user, isAuthenticated, logout } = useAuthStore();
  const { isDark, toggleTheme } = useThemeStore();
  const [showQR, setShowQR] = useState(false);
  const qrCanvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (showQR && qrCanvasRef.current && user) {
      const data = JSON.stringify({
        id: user.id,
        name: `${user.lastName} ${user.firstName}`.trim(),
        phone: user.phone
      });
      QRCode.toCanvas(qrCanvasRef.current, data, {
        width: 220,
        margin: 0,
        color: { dark: '#1e293b', light: '#ffffff' }
      });
    }
  }, [showQR, user]);

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside className={clsx(
        'fixed top-0 left-0 z-50 w-80 h-full theme-sidebar shadow-xl transform transition-transform duration-300 ease-in-out',
        isOpen ? 'translate-x-0' : '-translate-x-full'
      )}>
        {/* Header */}
        <div className="flex items-center justify-between p-6 theme-sidebar-header">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-emerald-600 rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-lg">LSC</span>
            </div>
            <div>
              <h1 className="font-bold theme-sidebar-title">Level Sport</h1>
              <p className="text-sm theme-sidebar-subtitle">Спортивный клуб</p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            className="p-2 theme-sidebar-close-button transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* User info - clickable for QR card */}
        {isAuthenticated && user && (
          <div
            className="p-6 theme-sidebar-user-section cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => setShowQR(true)}
          >
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                <span className="text-emerald-600 font-semibold text-lg">
                  {user.firstName?.[0]}{user.lastName?.[0]}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold theme-sidebar-user-name truncate">
                  {user.lastName} {user.firstName}
                </p>
                <p className="text-sm theme-sidebar-user-phone truncate">{user.phone}</p>
              </div>
              <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
              </svg>
            </div>
          </div>
        )}

        {/* Navigation */}
        <nav className="flex-1 p-4">
          <ul className="space-y-2">
            {navItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => clsx(
                    'flex items-center space-x-3 px-4 py-3 rounded-xl font-medium transition-colors theme-sidebar-nav-item',
                    isActive ? 'active' : ''
                  )}
                  onClick={onClose}
                >
                  {({ isActive }) => (
                    <>
                      {item.icon(isActive)}
                      <span>{item.label}</span>
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Footer */}
        <div className="p-4 theme-sidebar-footer">
          {/* Theme toggle */}
          <div className="flex items-center justify-between px-4 py-3 mb-2">
            <span className="text-sm font-medium theme-sidebar-theme-label">Темная тема</span>
            <button 
              onClick={toggleTheme}
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                isDark ? 'bg-emerald-600' : 'bg-gray-200 hover:bg-gray-300'
              }`}
            >
              <span className="sr-only">Toggle theme</span>
              <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                isDark ? 'translate-x-6' : 'translate-x-1'
              }`} />
            </button>
          </div>

          {isAuthenticated ? (
            <button
              onClick={() => {
                logout();
                onClose();
              }}
              className="flex items-center space-x-3 w-full px-4 py-3 theme-sidebar-logout-button rounded-xl font-medium transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span>Выйти</span>
            </button>
          ) : (
            <button
              onClick={() => {
                onLoginClick?.();
                onClose();
              }}
              className="flex items-center space-x-3 w-full px-4 py-3 theme-sidebar-login-button rounded-xl font-medium transition-colors bg-emerald-600 text-white hover:bg-emerald-700"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span>Войти в аккаунт</span>
            </button>
          )}
        </div>
      </aside>

      {/* QR Card Modal */}
      {showQR && user && (
        <div
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-60"
          onClick={() => setShowQR(false)}
        >
          <div
            className="relative w-[340px] max-w-[90vw] rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            style={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)' }}
          >
            {/* Close button */}
            <button
              onClick={() => setShowQR(false)}
              className="absolute top-3 right-3 p-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
            >
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="p-8 text-white">
              <div className="text-xl font-bold tracking-wider mb-1">
                LEVEL <span className="text-emerald-400">SPORT</span>
              </div>
              <div className="text-xs text-slate-400 uppercase tracking-widest mb-6">
                Карта клиента
              </div>

              <div className="mb-6">
                <div className="text-lg font-semibold">{user.lastName} {user.firstName}</div>
                <div className="text-slate-300 mt-1">{user.phone}</div>
                <div className="text-slate-500 text-sm mt-0.5">ID: {user.id}</div>
              </div>

              <div className="bg-white rounded-xl p-5 flex justify-center">
                <canvas ref={qrCanvasRef} />
              </div>

              {user.bonusBalance !== undefined && user.bonusBalance > 0 && (
                <div className="mt-4 text-center">
                  <span className="text-slate-400 text-sm">Бонусы: </span>
                  <span className="text-emerald-400 font-semibold">{user.bonusBalance} ₽</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}